import { xyzToCmyk, xyzToCss, xyzToHex, xyzToHsl, xyzToHsv, xyzToRgb } from ".";
import { round } from "../utils";
import { InvalidColorError, isValidLab } from "../validators";
const validator = (lab, converter) => {
    if (!isValidLab(lab))
        throw new InvalidColorError(lab, "CIELab");
    return converter;
};
const toXyz = (lab, options) => {
    const roundTo = (options === null || options === void 0 ? void 0 : options.roundTo) || 2;
    const xyzR = (options === null || options === void 0 ? void 0 : options.xyzRef) || { x: 95.047, y: 100.00, z: 108.883 };
    let _y = (lab.l + 16) / 116;
    let _x = lab.a / 500 + _y;
    let _z = _y - lab.b / 200;
    if (Math.pow(_y, 3) > 0.008856) {
        _y = Math.pow(_y, 3);
    }
    else {
        _y = (_y - 16 / 116) / 7.787;
    }
    if (Math.pow(_x, 3) > 0.008856) {
        _x = Math.pow(_x, 3);
    }
    else {
        _x = (_x - 16 / 116) / 7.787;
    }
    if (Math.pow(_z, 3) > 0.008856) {
        _z = Math.pow(_z, 3);
    }
    else {
        _z = (_z - 16 / 116) / 7.787;
    }
    return {
        x: round(_x * xyzR.x, roundTo),
        y: round(_y * xyzR.y, roundTo),
        z: round(_z * xyzR.z, roundTo)
    };
};
export const labToHex = (lab) => validator(lab, xyzToHex)(toXyz(lab));
export const labToCss = (lab, options) => validator(lab, xyzToCss)(toXyz(lab), options);
export const labToRgb = (lab) => validator(lab, xyzToRgb)(toXyz(lab));
export const labToHsl = (lab, options) => validator(lab, xyzToHsl)(toXyz(lab), options);
export const labToHsv = (lab, options) => validator(lab, xyzToHsv)(toXyz(lab), options);
export const labToCmyk = (lab) => validator(lab, xyzToCmyk)(toXyz(lab));
export const labToXyz = (lab, options) => validator(lab, toXyz)(lab, options);
